import { AppBar, Box, Container, Divider, Typography } from "@mui/material";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { Fragment } from "react";

export default function CustomerFooter() {
  return (
    <div className="content-footer">
      <div className="fotr-colunm">
        <p>
          © 2024 <strong>Gtech Distribution Private Limited.</strong> All Rights
          Reserved
        </p>
      </div>
    </div>
  );
}
